import React, { useMemo } from "react";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import UniversalTableDatasetButtonWrapper from "./UniversalTableDatasetButtonWrapper";
import { IUniversalDatasetTableRow } from "./interfaces";

interface DatasetButtonProps {
  dataset: DatasetDataInfoResponse;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  compactMode?: boolean;
  maxAge?: number;
  isExpired?: boolean;
}

const DatasetButton = ({
  dataset,
  columnIndex,
  rowData,
  compactMode,
  maxAge,
  isExpired,
}: DatasetButtonProps) => {
  const datasetData = dataset?.data?.length ? dataset.data[0] : null;
  const datasetTime = useMemo(
    () => (datasetData?.key ? new Date(datasetData.key as string) : null),
    [datasetData]
  );
  const datasetId = useMemo(
    () =>
      dataset
        ? `dataset-label-${dataset.identifier.split(":")[1]}-${dataset.identifier.split(":")[0]}`
        : null,
    [dataset]
  );

  const comProps = {
    columnIndex,
    rowData,
    compactMode,
    dataset,
    data: datasetData,
    time: datasetTime!,
  };

  return (
    <>
      {isExpired && (
        <UniversalTableDatasetButtonComponent
          {...comProps}
          id={datasetId ?? ""}
          isExpired={isExpired}
        />
      )}
      {!isExpired && (
        <UniversalTableDatasetButtonWrapper
          {...comProps}
          datasetId={datasetId ?? ""}
          maxAge={maxAge}
        />
      )}
    </>
  );
};

export default DatasetButton;
